/*
 * @Description: 
 * @version: 1.0.0
 * @Author: Monkey
 * @Date: 2025-03-05 14:57:01
 * @LastEditors: Monkey
 * @LastEditTime: 2025-07-07 17:23:21
 */
import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/display.css'
import scui from './scui'
import i18n from './locales'
import router from './router'
import store from './store'
import App from './App.vue'

const app = createApp(App);

import FcDesigner from '@form-create/designer';

app.use(store);
app.use(router);
app.use(ElementPlus);
app.use(i18n);
app.use(scui);

app.use(FcDesigner);
app.use(FcDesigner.formCreate);



//挂载app
app.mount('#app');